import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { MenuItem, MenuList, Button, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { PURCHASE_STATUSES } from '../Utils/constants';

const useStyles = () => ({
  root: {
    minWidth: '10vw',
  },
});

const PurchaseFilters = function PurchaseFilters({
  onChangeFilters,
  defaultValue,
  onClose = () => {},
  userInfo,
}) {
  const intl = useIntl();
  const classes = useStyles();

  const [selectedStatus, setSelectedStatus] = useState(defaultValue);
  const purchaseFilter = userInfo.userRoles.some(
    ({ roleId }) => roleId === 'ACCOUNTING'
  )
    ? [PURCHASE_STATUSES[1], PURCHASE_STATUSES[2], PURCHASE_STATUSES[3]]
    : PURCHASE_STATUSES;

  const handleChangeSelectedStatus = (event, newStatus) => {
    if (newStatus === selectedStatus) {
      setSelectedStatus(null);
    } else {
      setSelectedStatus(newStatus);
    }
  };

  return (
    <div style={classes.root}>
      <Typography
        variant="caption"
        color="primary"
        sx={{ fontWeight: 'bold', mb: '8px' }}
      >
        {intl.messages.PURCHASE_STATE}
      </Typography>
      <MenuList>
        {purchaseFilter.map((status) => (
          <MenuItem
            disableGutters
            sx={{
              display: 'flex',
              pr: '2px',
              pl: '8px',
              justifyContent: 'space-between',
              borderRadius: '5px',
              color: (theme) =>
                selectedStatus === status && theme.palette.primary.main,
              '&.Mui-selected': {
                background: 'white.main',
                fontWeight: 'bold',
              },
            }}
            key={status}
            selected={selectedStatus === status}
            onClick={(e) => handleChangeSelectedStatus(e, status)}
          >
            {intl.messages[status]}
            {status === selectedStatus && <CheckIcon />}
          </MenuItem>
        ))}
      </MenuList>
      <Button
        id="confirm-filters-btn"
        onClick={() => {
          onChangeFilters(selectedStatus);
          onClose();
        }}
        sx={{ marginTop: '16px' }}
        size="small"
        fullWidth
      >
        {intl.messages.CONFIRM}
      </Button>
    </div>
  );
};

export default PurchaseFilters;
